import React from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import bgImg from "../Assets/Images/property4.jpg";

const Contact = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="relative bg-secondaryx h-96">
        <img
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay"
          src={bgImg}
          alt="NGO volunteers"
        />
        <div className="absolute inset-0 bg-secondaryx bg-opacity-75"></div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">Contact Us</h1>
          <p className="mt-6 text-xl text-blue-100 max-w-3xl">
            We're here to listen, help, and make a difference. Reach out to us and be a part of our mission to create positive change.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white shadow-md shadow-white rounded-lg p-8">
            <h2 className="text-2xl font-roboto text-secondary mb-6">Send us a message</h2>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium py-2 text-gray-700">Name</label>
                <input type="text" id="name" name="name" className="mt-1 block w-full border-primary rounded-md shadow-sm py-4 border-[1.2px] focus:ring-blue-500 focus:border-blue-500" />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium py-2 text-gray-700">Email</label>
                <input type="email" id="email" name="email" className="mt-1 block w-full border-primary rounded-md shadow-sm py-4 border-[1.2px] focus:ring-blue-500 focus:border-blue-500" />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium py-2 text-gray-700">Message</label>
                <textarea id="message" name="message" rows="4" className="mt-1 block w-full border-primary rounded-md shadow-sm py-4 border-[1.2px] focus:ring-blue-500 focus:border-blue-500"></textarea>
              </div>
              <div>
                <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  Send Message
                </button>
              </div>
            </form>
          </div>

          <div className="bg-gray-50 rounded-lg p-8">
            <h2 className="text-2xl font-roboto text-secondary mb-6">Get in touch</h2>
            <div className="space-y-6">
              <div className="flex items-center">
                <FaEnvelope className="h-6 w-6 text-blue-600 mr-3" />
                <span className="text-gray-600">traderockfx@gmail.com</span>
              </div>
              <div className="flex items-center">
                <FaMapMarkerAlt className="h-6 w-6 text-blue-600 mr-3" />
                <span className="text-gray-600">Miami, Florida at 1111 Brickell Avenue, Suite 2724, Miami FL 33131</span>
              </div>
            </div>
            <div className="mt-8">
              <img
                className="w-full h-48 object-cover rounded-lg"
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1469&q=80"
                alt="NGO office"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <div className="bg-white shadow-xl shadow-white rounded-lg overflow-hidden">
          <iframe
            title="NGO Location"
            className="w-full h-96"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.7152203737237!2d-118.24368384955848!3d34.05267002569399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c64f0f4d3d59%3A0x24e8c0520c02b9d8!2sLos%20Angeles%20City%20Hall!5e0!3m2!1sen!2sus!4v1655071878274!5m2!1sen!2sus"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
